module.exports = __webpack_public_path__ + "img/classic_rental20_1.023afc4d.jpg";